import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

const H3_TITLE_HEIGHT = 32 + 8; // height + margin-bottom
const NO_REVIEWS_HEIGHT = 360;

export const MainContent = styled.div``;

export const ReviewsContent = styled.div`
  min-height: ${H3_TITLE_HEIGHT + NO_REVIEWS_HEIGHT}px;
`;

export const PropertiesTabContent = styled.div`
  min-height: 255px;

  ${media.mediumUp`
    min-height: 750px;
  `}
`;

export const StatisticsTabContent = styled.div`
  min-height: 343.094px;

  ${media.mediumUp`
    min-height: 507.094px;
  `}

  ${media.mediumUp`
    min-height: 549.5px;
  `}
`;
